import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children, defaultLang = "ro" }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || defaultLang);
  const [currency, setCurrency] = useState(() => localStorage.getItem("currency") || "EUR");

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  const t = (path) => {
    const keys = path.split(".");
    let current = translations[lang] || translations.ro;
    for (const k of keys) {
      current = current?.[k];
      if (current === undefined) return path;
    }
    return current;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, currency, setCurrency, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
